import React from 'react'
import PropTypes from 'prop-types'

import {Box, Heading, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

export const CategoryBanner = (pdData) => {
    const desktopCatBannerImgUrl = pdData?.desktopCategoryImage?.url
    const mobileCatBannerImgUrl = pdData?.mobileCategoryImage?.url ?? desktopCatBannerImgUrl
    if (desktopCatBannerImgUrl) {
        return (
            <Box position="relative">
                <picture>
                    <source
                        media="(min-width: 768px)"
                        srcSet={`${desktopCatBannerImgUrl}`}
                        type="image/jpg"
                    />
                    <img
                        style={{
                            backgroundSize: 'cover',
                            height: '400px',
                            width: '100%',
                            maxHeight: '70vh',
                            objectFit: 'cover'
                        }}
                        src={`${mobileCatBannerImgUrl}`}
                        alt="Description"
                    />
                </picture>
                <Box
                    color="white"
                    textAlign="center"
                    position="absolute"
                    zIndex="1"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                >
                    {pdData?.heading && <Heading>{`${pdData?.heading}`}</Heading>}
                    {pdData?.summary && <Text>{`${pdData?.summary}`}</Text>}
                </Box>
            </Box>
        )
    }
}

CategoryBanner.propTypes = {
    image: PropTypes.shape({
        _type: PropTypes.string,
        focalPoint: PropTypes.shape({
            _type: PropTypes.string,
            x: PropTypes.number,
            y: PropTypes.number
        }),
        metaData: PropTypes.shape({
            _type: PropTypes.string,
            height: PropTypes.number,
            width: PropTypes.number
        }),
        url: PropTypes.string,
        alt: PropTypes.string,
        src: PropTypes.string || PropTypes.object
    })
}

export default CategoryBanner
